import { render, staticRenderFns } from "./Print_health.vue?vue&type=template&id=0f963d8c&scoped=true"
import script from "./Print_health.vue?vue&type=script&lang=js"
export * from "./Print_health.vue?vue&type=script&lang=js"
import style0 from "./Print_health.vue?vue&type=style&index=0&id=0f963d8c&prod&scoped=scoped&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f963d8c",
  null
  
)

export default component.exports